<template>
  <div class="invoice-modal">
    <div class="invoice-modal__status">
      <span class="invoice-modal__label">Статус:</span>
      <span class="invoice-modal__value">{{ this.data.realization.is_send_to_1c }}</span>
    </div>
    <CustomTable :rowsData="this.realizationItems" :columns="invoiceColumns" :custom-body="true" :striped="true"
      :hoverless="true" :bordered="true" row-key="request_id" :bottomRow="true">
      <template #customBody="props">
        <q-tr :props="props">
          <CustomTableCell align="center" vertical-align="center">
            {{ props.row.material_id }}
          </CustomTableCell>
          <CustomTableCell align="left" vertical-align="center">
            {{ props.row.material_name }}
          </CustomTableCell>
          <CustomTableCell align="center" vertical-align="center">
            {{ props.row.material_cnt }}
          </CustomTableCell>
          <CustomTableCell align="center" vertical-align="center">
            {{ props.row.sell_unit_name }}
          </CustomTableCell>
          <CustomTableCell align="center" vertical-align="center">
            {{ props.row.material_price }}
          </CustomTableCell>
          <CustomTableCell align="center" vertical-align="center">
            {{ this.numberWithCommas(props.row.material_sum.toFixed(2)) }}
          </CustomTableCell>
        </q-tr>
      </template>
      <template #bottomRow>
        <q-tr class="sticky-bottom-row">
          <CustomTableCell align="center" vertical-align="center" colspan="5">
            <strong>Итого:</strong>
          </CustomTableCell>
          <CustomTableCell align="center" vertical-align="center">
            <strong>{{ this.numberWithCommas(this.data.realization.realize_sum) }}</strong>
          </CustomTableCell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { numberWithCommas } from '@/services'
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { invoiceColumns, getRealizationItems } from "@/views/TradingHouse/services";

export default {
  name: 'ProviderRealizationInfo',
  components: { CustomTable, CustomTableCell },
  props: ['data'],
  data() {
    return {
      invoiceColumns,
      realizationItems: [],
      loading: false,
      params: {
        realize_id: this.data?.realization?.realize_id,
      },
    }
  },
  computed: {
    realization() {
      return this.data?.realization || {}
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true;
      const res = await getRealizationItems(this.params);
      this.loading = false;
      if (!res) return;
      this.realizationItems = res;
    },
    numberWithCommas,
  },
}
</script>

<style scoped lang="scss">
.invoice-modal {
  min-width: 360px;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 5px;

  :deep(.custom-table) {
    --tbl-radius: 8px !important;
    border-radius: 8px !important;
  }

  :deep(.q-table tbody td) {
    font-size: 12px;
  }

  &__status {
    display: flex;
    gap: 4px;
  }
}

.invoice-modal__row {
  display: flex;
  gap: 8px;
  font-size: 14px;
}

.invoice-modal__label {
  font-weight: 600;
}

.invoice-modal__value {
  color: #0F6CBD;
}

:deep(.sticky-bottom-row) {
  background: #f9fafb;
  font-weight: 600;

  td {
    border-top: 2px solid #e5e7eb;
    padding: 12px 8px;
  }
}
</style>
